// src/Data/categoryImages.js
export const categoryImages = {
  "wedding": "/images/wedding.jpeg",
  "family-session": "/images/family-session.jpeg",
  "couple-session": "/images/couple-session.jpeg",
  "brand": "/images/brand.jpeg",
  "social-media-content": "/images/colab.jpeg",
  "monthly-content": "/images/monthly-content.jpeg",
};
